import { render, staticRenderFns } from "./CollectionsView.vue?vue&type=template&id=542acf25&lang=pug&"
import script from "./CollectionsView.vue?vue&type=script&lang=js&"
export * from "./CollectionsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports